import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent } from '@angular/common/http';
import { Observable } from 'rxjs';

// 🔀 Ajout du X-Api-Name (multi-API Gateway)
@Injectable()
export class ApiNameInterceptor implements HttpInterceptor {
  // Définir la valeur de l'apiName (peut être injectée via une configuration si nécessaire)
  private readonly apiName = 'WebAppExtClient';

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    // Cloner la requête et ajouter l'en-tête X-Api-Name
    const modifiedReq = req.clone({
      setHeaders: {
        'X-Api-Name': this.apiName
      }
    });

    // Passer la requête modifiée au handler suivant
    return next.handle(modifiedReq);
  }
}